/*
 * Copyright 1999-2025 Jagex Ltd.
 */
export class AuthError extends Error {
  constructor(message) {
    super(message);
  }
}
